import React from "react";

const Loader = ({ isLoading, text = "Loading..." }) => {
  if (!isLoading) return null;

  return (
    <div
      className=" fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      aria-label="Loading..."
      role="status"
    >
      {/* <div className="bg-white rounded-lg p-8 flex flex-col items-center space-y-4">
        <svg className="h-20 w-20 animate-spin stroke-gray-500" viewBox="0 0 256 256">
          <line
            x1="128"
            y1="32"
            x2="128"
            y2="64"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="195.9"
            y1="60.1"
            x2="173.3"
            y2="82.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="224"
            y1="128"
            x2="192"
            y2="128"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="195.9"
            y1="195.9"
            x2="173.3"
            y2="173.3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="128"
            y1="224"
            x2="128"
            y2="192"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="60.1"
            y1="195.9"
            x2="82.7"
            y2="173.3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="32"
            y1="128"
            x2="64"
            y2="128"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
          <line
            x1="60.1"
            y1="60.1"
            x2="82.7"
            y2="82.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="24"
          ></line>
        </svg>
        <span className="text-4xl font-medium text-gray-500">{text}</span>
      </div> */}
      <div className="bg-black rounded-lg p-8 loader">
        <div className="slider " style={{ "--i": 0 }} />
        <div className="slider" style={{ "--i": 1 }} />
        <div className="slider" style={{ "--i": 2 }} />
        <div className="slider" style={{ "--i": 3 }} />
        <div className="slider" style={{ "--i": 4 }} />
      </div>
    </div>
  );
};

export default Loader;
